type PeriodUnit = 'day' | 'week' | 'month' | 'year';

export interface PriceItem {
  amount: number;
  cost: number;
  language: PriceItemLanguage;
  currency: PriceItemCurrency;
  type?: PriceType;
  balanceSubscription?: {
    quantity: number;
    period: number;
    periodUnit: PeriodUnit;
    balanceTrial: {
      trialPeriod: number;
      trialPeriodUnit: PeriodUnit;
      trialQuantity: number;
    };
  };
  accessSubscription?: {
    period: number;
    periodUnit: PeriodUnit;
    accessTrial: {
      trialPeriod: number;
      trialPeriodUnit: PeriodUnit;
    };
  };
}

export type PriceType = 'balance_subscription' | 'access_subscription' | 'product' | 'certificate';

export interface PriceItemPerLesson extends PriceItem {
  perLesson: number;
}

export enum PriceItemLanguage {
  en = 'en',
  ru = 'ru',
  math = 'math',
  default = 'default',
}

export type PriceItemCurrency =
  | 'RUB'
  | 'EUR'
  | 'USD'
  | 'PLN'
  | 'KRW'
  | 'JPY'
  | 'AOA'
  | 'TRY'
  | 'BRL'
  | 'SAR'
  | 'AED'
  | 'BHD'
  | 'QAR'
  | 'MYR'
  | 'THB'
  | 'CLP'
  | 'MXN'
  | 'INR'
  | 'ARS'
  | 'PAB'
  | 'ILS'
  | 'CHF'
  | 'CZK'
  | 'NOK'
  | 'UYU'
  | 'GTQ'
  | 'IDR'
  | 'DKK'
  | 'SEK'
  | 'BGN'
  | 'PEN'
  | 'LVL'
  | 'HUF'
  | 'ZMW'
  | 'CDF'
  | string;
